app.service('relatedAccessories', function (cartManager, basketAnalytics, broker, pageConfig,
	console, scroll, productDetailsModal, lazyLoad, front, simpleToastr, toCartError) {
	function add(params) {
		cartManager.simpleAddProduct({
			productId: params.productId,
			addedFrom: 'CART_EDIT'
		}, function () {
			basketAnalytics.addRelatedAccessory({
				productId: params.productId,
				parentId: params.parentId,
				from: 'button'
			});
			scroll.to({ $element: $('#cart-summarize') });
			simpleToastr.afterReloadMessage(`<h2>Produkt dodany do koszyka</h2><p>${params.productName}</p>`);
			broker.trigger('REFRESH_BASKET_VIEW');
		}, function (json) {
			const parent = pageConfig.getData('basket').items.filter(function (e) {
				return e.id == params.parentId;
			});
			if (parent.length) {
				const cartErrorData = {			// do przeniesienia gdzieś dalej
					productId: parent[0].plu,
					productStatus: 'new',
					paymentType: basketAnalytics.paymentType(),
					errorMessage: json.notPossibleAddToCartReason || 'other',
					callFromElement: 'button',
					productType: 'akc',
					isOperatorMode: pageConfig.isOperatorMode,
				}
				toCartError.sendEventAddToCartError(cartErrorData);
			}
		}
		);
	}
	function right($el) {
		const $list = $el.closest('.list-box').find('.list');
		const size = $list.data('size');
		if (size > 1) {
			if (front.getBrakepoint() === "desktop") {
				$list[0].scrollLeft = 0;
			}
			let scroll = $list.attr('data-scroll') / 1 || 0;
			scroll++;
			$list.attr('data-scroll', Math.min(scroll, size));
		}
	}
	function left($el) {
		const $list = $el.closest('.list-box').find('.list');
		if ($list.data('size') > 1) {
			if (front.getBrakepoint() === "desktop") {
				$list[0].scrollLeft = 0;
			}
			let scroll = $list.attr('data-scroll') / 1 || 0;
			scroll--;
			$list.attr('data-scroll', Math.max(0, scroll));
		}
	}
	function init() {
		const $box = $('.related-accessories .list-box');

		$('.js-related-product', $box).on('click', function (e) {
			if (!($(e.target).is('a.js-energy-card') || $(e.target).is('a.js-energy-label') || $(e.target).closest('.js-durability-guarantee').length)) {
				const productName = $(this).find('.related-product-name').text().trim();
				const productId = $(this).data('product');
				const productPlu = $(this).data('product-plu');
				const parentId = $(this).data('parent');
				productDetailsModal.open({
					productId: productId,
					productPlu: productPlu,
					parentId: parentId,
					callbackAdded: function () {
						basketAnalytics.addRelatedAccessory({
							productId: productId,
							parentId: parentId,
							from: 'fancybox'
						});
						scroll.to({ $element: $('#cart-summarize') });
						simpleToastr.afterReloadMessage(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
						broker.trigger('REFRESH_BASKET_VIEW', { type: 'relatedAccessories-modal', productId: productId });
					}
				});
				UA.interaction('Koszyk - K1', 'Warstwa ze szczegółami akcesorium', 'Kliknięcie');
			}
		}).on('focus', function () {
			lazyLoad.update();
		}).on('keyup', function (event) {
			nextTab(event);
		});
		$('a.related-product', $box).on('keyup', function (event) {
			nextTab(event);
		});
		function nextTab(event) {
			let $el = $(event.target);
			if (event.key == 'Tab') {
				check($el.closest('.related-product'));
				event.preventDefault();
				event.stopPropagation();
			}
		}
		function check($el) {
			if ($el && $el.length) {
				let item = $el[0].getBoundingClientRect();
				let list = $el.closest('.list')[0].getBoundingClientRect();
				if (item.x < list.x) {
					console.log('Tablowanie w lewo');
					left($el);
					setTimeout(function () {
						check($el);
					}, 200);
				} else if (item.x + item.width > list.x + list.width) {
					console.log('Tablowanie w lewo');
					right($el);
					setTimeout(function () {
						check($el);
					}, 200);
				}
			}
		}

		$('.js-add-related-accessory', $box).click(function (event) {
			event.stopPropagation();
			add({
				productId: $(this).data('product'),
				parentId: $(this).data('parent'),
				productName: $(this).parents('.related-product-content').find('.related-product-name').text().trim()
			});
		});
		$('.js-slide-right', $box).click(function () {
			right($(this));
		});
		$('.js-slide-left', $box).click(function () {
			left($(this));
		});

	}
	return {
		init
	};
});
